export const PRODUCT_TYPES = [
    {
        value: 1,
        label: '现货'
    },
    {
        value: 2,
        label: '合约'
    },
    {
        value: 3,
        label: '超级合约'
    },
    {
        value: 4,
        label: '活期宝'
    },
    {
        value: 5,
        label: '定期宝'
    }
];
export const RANK_TYPES = [
    {
        value: 1,
        label: '交易量'
    },
    {
        value: 2,
        label: '净买入'
    },
    {
        value: 3,
        label: '盈利率'
    },
    {
        value: 4,
        label: '盈利额'
    },
    {
        value: 5,
        label: '持仓量'
    }
];
export const LANGUAGES = [
    {
        value: 'zh',
        label: '中文'
    },
    {
        value: 'en',
        label: '英文'
    },
    {
        value: 'kr',
        label: '韩文'
    },
    {
        value: 'vi',
        label: '越南语'
    }
];